import Storage from 'web-storage-cache'
const localStorage = new Storage()

// 设置localStorage
export function setLocalStorage(key, value) {
  return localStorage.set(key, value)
}

// 获取localStorage
export function getLocalStorage(key) {
  return localStorage.get(key)
}

// 移除localStorage
export function removeLocalStorage(key) {
  return localStorage.delete(key)
}

// 清空localStorage
export function clearLocalStorage() {
  return localStorage.clear()
}

// 存储聊天记录,外层是一个数组，数组中包含着每一个聊天记录对象
export function setChatMessage(user, value) {
  let chat = JSON.parse(getLocalStorage(`${user}-chatHistory`))
  if (!chat) {
    chat = []
  }
  chat.push(value)
  setLocalStorage(`${user}-chatHistory`, JSON.stringify(chat))
}




// WEBPACK FOOTER //
// ./src/utils/localStorage.js